import { createCampaignSettings } from '../../campaigns/utils/campaignUtils';
import { useShowConsumerCampaignById } from './get';

const useShowConsumerCampaignSettingsById = ({
  campaignId,
  causeId,
}: {
  campaignId?: string;
  causeId?: string;
}) => {
  return useShowConsumerCampaignById({
    campaignId,
    causeId,
    select: createCampaignSettings,
  });
};

export { useShowConsumerCampaignSettingsById };
